export enum PaymentMethod {
  Swish = 'SWISH',
  PayLater = 'PAY_LATER',
}
